class AppLocalStorage {
    getValue(key, defaultValue = '') {
        return window.localStorage.getItem(key) || defaultValue;
    }
    getObject(key) {
        const json = this.getValue(key);
        return json ? JSON.parse(json) : {};
    }
    setValue(key, value = '') {
        window.localStorage.setItem(key, value);
    }
}

const AppState = new AppLocalStorage();

export default AppState;
